// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3r82I","placeholdersHeader":"styles_placeholdersHeader__2s7ah","editorStyle":"styles_editorStyle__1uwYc","placeholdersBox":"styles_placeholdersBox__3_mYT"};